//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

// #region Imports
import { EthAddr } from '@shared/SchemaTypes'
import { Signer } from 'ethers'

import { ActivityEnum, AlertLevelEnum, RoleEnum } from '@shared/Enums'

import { poolActions } from '@react/redux/poolSlice'

import { logOT } from '@shared/loggingShared'

import { ThunkAction, UnknownAction } from '@reduxjs/toolkit'

import { assertRole, dispatchError, OtStoreState } from '@react/redux/store'

import { ERC20Wei, erc20WeiToCommaDecString, otAssert } from '@shared/conversions'

import { AlertCTO } from '@shared/AlertCTO'

import { alertActions } from '@react/redux/alertSlice'

import { depositToPool } from '@shared/poolActions'
import { dateToEthDate } from '@shared/SchemaTypes'

export const depositToPoolTx =
  (props: { poolAddr: EthAddr; amountWei: ERC20Wei }): ThunkAction<void, OtStoreState, unknown, UnknownAction> =>
  async (dispatch, getState): Promise<void> => {
    const activity = ActivityEnum.POOL_DEPOSIT
    const { poolAddr, amountWei } = props

    try {
      logOT.debug('depositToPool 1')

      const { webSocket, userConnection } = getState().chainState
      const { chainConfigurationName, providerReadOnly } = getState().chainState.chainConfiguration
      otAssert(providerReadOnly, 'providerReadOnly is not defined')
      otAssert(userConnection, 'userConnection is not defined')
      const { roleEnum, signer } = userConnection
      assertRole(roleEnum, RoleEnum.LENDER)

      await depositToPool(webSocket, signer as Signer, providerReadOnly, poolAddr, amountWei, chainConfigurationName)

      dispatch(poolActions.depositToPoolSuccess({ poolAddr, amountWei }))

      const depositSuccess: AlertCTO = {
        alertLevel: AlertLevelEnum.SUCCESS,
        title: `Successfully invested ${erc20WeiToCommaDecString(amountWei)} `,
        description: '',
        sourceObjectAddr: poolAddr,
        createdAt: dateToEthDate(new Date()),
        dueDateTime: 0,
      }
      dispatch(alertActions.addAlert(depositSuccess))
    } catch (e: any) {
      dispatch(poolActions.depositToPoolFail({ poolAddr, amountWei }))

      await dispatchError(dispatch, e, activity, 1009)
    }
  }
